import axios from "@/lib/axios";

const getTrialLens = () => {
  return axios.get("/facility/orders/trial_lens");
}

export default getTrialLens;